import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';
import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';

import 'inventory-listing/components/ListingHeader/ListingHeader.scss';

const ListingHeader = ({ title, colanderGroupSlug }) => {
    let content;
    let url;
    let banner;

    // Used banner by default
    content = ContentZonesService.getContentZone('widget.listing.used', 'widget.listing.used.buy.online.banner');
    url = ContentZonesService.getContentZone('widget.listing.used', 'widget.listing.used.buy.online.banner.url.used');

    // New banner if colander group is New
    if (colanderGroupSlug === COLANDER_GROUPS.NEW) {
        const newContent = ContentZonesService.getContentZone(
            'widget.listing.used',
            'widget.listing.used.buy.online.banner.new'
        );

        // If new banner is available, re-assign `content` and `url`
        if (newContent && newContent.getValue()) {
            content = newContent;
            url = ContentZonesService.getContentZone(
                'widget.listing.used',
                'widget.listing.used.buy.online.banner.url.new'
            );
        }
    }

    if (content && content.getValue()) {
        banner =
            url && url.getValue() ? (
                <a target="_blank" rel="noopener noreferrer" href={url.getValue()}>
                    <img src={content.getValue()} alt={LocaleService.t('HEADER_BANNER')} />
                </a>
            ) : (
                <img src={content.getValue()} alt={LocaleService.t('HEADER_BANNER')} />
            );
    }

    return (
        <div className="listing-used-header">
            <div className="listing-used-banner">{banner}</div>
            <h1 className="sr-title-1 is-centered">{title}</h1>
        </div>
    );
};

ListingHeader.defaultProps = {
    colanderGroupSlug: COLANDER_GROUPS.DEFAULT,
};

ListingHeader.propTypes = {
    title: PropTypes.string.isRequired,
    colanderGroupSlug: PropTypes.string,
};

ListingHeader.displayName = 'ListingHeader';

export default ListingHeader;
